import React, { useEffect, useRef } from "react";
import useSendAnalyticsEvent from "lib/hooks/useAnalytics";
import { analyticsEvents, analyticsTypes } from "lib/utils/constants";
import "react-phone-number-input/style.css";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import TrustBadges from "components/common/TrustBadges";
import TermsConditions from "components/common/TermsConditions";
import Login from "components/auth/Login";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";

interface MultiFactorAuthenticationProps {
  setOpenDialog?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MultiFactorAuthentication: React.FC<MultiFactorAuthenticationProps> = ({}) => {
  const { sendAnalyticsEvent } = useSendAnalyticsEvent();
  const {
    state: { checkoutItems },
    actions: { setCheckoutView },
  } = useCheckoutContext();
  const {
    state: { merchant },
  } = useMerchantContext();

  //** Side Effects */
  useEffect(() => {
    //Login page loaded event
    if (merchant?.merchantId && checkoutItems?.length > 0) {
      sendAnalyticsEvent({
        eventName: analyticsEvents.FLO_AUTH_PHONE_LOADED,
        eventFor: [analyticsTypes.SF_ANALYTICS, analyticsTypes.FACEBOOK_PIXEL],
        eventType: "load",
        metaData: {
          checkoutItems: checkoutItems,
        },
      });
    }
    setCheckoutView("AUTH");
  }, [merchant?.merchantId, checkoutItems]);

  return (
    <>
      <Login context={"AUTH"} />
      <TrustBadges />
      <TermsConditions />
    </>
  );
};

export default MultiFactorAuthentication;
